module.exports = __webpack_public_path__ + "img/gwbg.54c00e62.png";